import { createPortal } from 'react-dom';
import { AnimatePresence } from 'framer-motion';
import { Body, ContainerBox } from './index.styles';
import { useBackgroundUploaderContext } from './context';
import { Header, UploadingFile } from './components';

export const BackgroundUploader = () => {
  const { uploadingFiles, isMinimised } = useBackgroundUploaderContext();

  return createPortal(
    <ContainerBox data-testid="BackgroundUploader_test">
      <Header />
      <Body>
        <ul>
          <AnimatePresence>
            {!isMinimised &&
              Object.values(uploadingFiles)
                .reverse()
                .map((media, index) => (
                  <UploadingFile
                    key={media.id}
                    index={index}
                    {...media}
                  />
                ))}
          </AnimatePresence>
        </ul>
      </Body>
    </ContainerBox>,
    document.getElementById('root') as HTMLElement
  );
};
